import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-filePermit",
  "use": "icon-filePermit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-filePermit\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 159.48032C128 89.0752 185.49216 32 256.218752 32L646.703104 32 896 287.23456 896 864.37248C896 934.85888 838.2752 992 767.45408 992L256.54592 992C185.552 992 128 934.8224 128 864.51968L128 159.48032ZM576 320C576 337.67296 590.326912 352 608 352L896 352 896 288 640 288 640 32 576 32 576 320ZM442.30656 787.03808C458.87552 803.60704 485.487936 804.38912 503.00128 788.82112L763.426368 557.33248C781.694144 541.0944 783.339584 513.12192 767.101568 494.8544 750.863488 476.58624 722.891008 474.9408 704.623168 491.17888L477.142592 696.70144 389.148416 608.7072C371.865664 591.424 343.8448 591.424 326.562048 608.7072 309.279296 625.98976 309.279296 654.01088 326.562048 671.29344L442.30656 787.03808Z\" p-id=\"1272\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/filePermit.svg
// module id = SuHx
// module chunks = 25